/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-use-before-define: 0, no-var: 0 */
/* globals _, Backbone, JSWidget, mp */

_.namespace(`mp.widgets`, function(ns) {
  'use strict';

  var DEFAULT_MAX_SELECTORS = 6;

  function ColorToggleDropdown() {
    this.class_name = `color_toggle_dropdown`;
    this.label_class = ColorToggleLabel;
  }
  _.inherit(ColorToggleDropdown, mp.widgets.dropdowns.Filterable);

  function ColorToggleLabel() {
    this.class_name = `color_toggle_label`;
  }
  _.inherit(ColorToggleLabel, mp.widgets.Dropdown.Label);

  ColorToggleLabel.prototype.create = function(container, config) {
    this.color = config.color;
    this.color_checkbox = !!config.color_checkbox;
    this.disable_selection = !!config.disable_selection;

    container = (container || $(`<div>`)).toggleClass(`color_checkbox`, this.color_checkbox);

    this.title = $(`<div>`).addClass(`title`);
    this.checkbox = $(`<div>`).addClass(`checkbox active`);
    var $color_el = this.color_checkbox ? this.checkbox : $(`<div>`).addClass(`color_circle`);

    $color_el.css({
      'background-color': this.color,
      'border-color': this.color,
    });

    container.mousedown(_.bind(function(ev) {
      if ($(ev.target).closest(`.checkbox, .dropdown_label_widget.disabled`).length) {
        container.addClass(`mousedown`);
      }
    }, this));

    // This should be registered before 'create' so that the callback happens before the dropdown callback,
    // which allows toggling the checkbox without activating the dropdown menu.
    container.mouseup(_.bind(function(ev) {
      // toggle on checkbox click, or click anywhere in the dropdown label if the dropdown is disabled
      if ($(ev.target).closest(`.checkbox, .dropdown_label_widget.disabled`).length) {
        container.closest(`#multi_selector`).find(`.` + this.class_name).removeClass(`mousedown`);
        ev.stopImmediatePropagation(); // stop the event from triggering the dropdown menu handler

        this.toggle_checked();

        _.delay(_.bind(function() { // delay slightly so the ui feels more responsive
          this.checkbox.trigger(`change`);
        }, this), 100);
      }
    }, this));

    ColorToggleLabel.superclass.create.call(this, container, config);

    // this.checkbox and $color_el might be the same element, in which case it will only be appended once
    this.container.append(this.checkbox, $color_el, this.title, $(`<div>`).addClass(`arrow`));
    this.container.on(`label-changed`, _.bind(function() {
      if (this.title.text()) {
        this.title.attr(`title`, this.title.text());
      }
    }, this));

    if (this.disable_selection) {
      this.checkbox.hide();
    }

    return this;
  };

  ColorToggleLabel.prototype.toggle_checked = function(toggle) {
    this.checkbox.toggleClass(`active`, toggle);

    if (this.color_checkbox) {
      if (toggle || this.checkbox.hasClass(`active`)) {
        this.checkbox.css({
          'background-color': this.color,
          'border-color': this.color,
        });
      } else {
        this.checkbox.css({
          'background-color': ``,
          'border-color': ``,
        });
      }
    }
  };

  var MultiSelector = function() {
    this.class_name = `multi_selector`;
  };
  _.inherit(MultiSelector, JSWidget);

  MultiSelector.prototype.create = function(config) {
    MultiSelector.superclass.create.call(this, config.container);

    this.outer_container = config.outer_container || config.container;

    this.dropdowns = [];
    this.callback = config.callback;
    this.default_label = config.default_label;

    // Set to true if we don't allow individual segments to be checked
    // or unchecked by user clicks
    this.is_selection_disabled = false;

    // If true, don't disable the selected item in dropdowns
    this.is_selected_item_enabled = !!config.enable_selected_item;

    // Max number of selectors to show across top of chart
    this.max_selectors_to_show = DEFAULT_MAX_SELECTORS;

    // Used for when update_static_values is called
    this.static_state = [];

    // Used to determine whether we should rebuild our dropdowns on update
    this.values = undefined;

    // Used as the color scheme passed to mp.charts.nth_color
    this.color_scheme = config.color_scheme;

    // If true, combine color dots with checkboxes
    this.color_checkboxes = !!config.color_checkboxes;

    // If true, use a single checkbox dropdown instead of individual dropdowns
    this.single_dropdown = !!config.single_dropdown;
    this.single_dropdown_text = config.single_dropdown_text; // slideout helper text for dropdown button
    this.single_dropdown_max_selected = config.single_dropdown_max_selected; // max items that may be selected at one time

    if (this.single_dropdown) {
      var MultiSelect = Backbone.widgets.MultiColumnMultiSelect;
      var CompareSelect = MultiSelect.extend({
        templates: $.extend({}, MultiSelect.prototype.templates, {
          selections_area: `<div class="select_button"><div class="icon"></div></div>`,
        }),
      });

      this.compare_select = new CompareSelect({
        classes: [`compare_select`],
        model: new Backbone.data.MultiSelectModel(),
        selected_first: true,
        clear_search_on_show_menu: true,
        max_selected: this.single_dropdown_max_selected,
        show_selected_count: true,
        delay_model_changes: 100,
      });
      this.compare_select.render().$el.appendTo(this.container);
      this.compare_select
        .on(`user_changed_selection`, function(new_values) {
          this.update_dropdowns(new_values);
        }, this)
        .on(`show_menu`, function() { // We need to add a class to properly handle animations of line bewteen compare button and select menu
          _.defer(_.bind(function() { // defer adding class so that transitions happen
            this.compare_select.$(`.select_button`).addClass(`hide_text`);
          }, this));
        }, this)
        .on(`hide_menu`, function() {
          this.compare_select.$(`.select_button`).removeClass(`hide_text`);
        }, this);

      if (this.single_dropdown_text) {
        this.compare_select.$(`.select_button`).addClass(`show_text`)
          .prepend($(`<div>`).addClass(`text`).text(this.single_dropdown_text));
      }
    }

    this.reset_container();
    return this;
  };

  MultiSelector.prototype.reset_container = function() {
    this.container.children().not(`.compare_select`).remove();
  };

  MultiSelector.prototype.disable_selection = function() {
    this.is_selection_disabled = true;
  };

  MultiSelector.prototype.disable = function() {
    this.update_values([]);
  };

  MultiSelector.prototype.disable_all_dropdowns = function() {
    _.each(this.dropdowns, function(dropdown) {
      dropdown.disable();
      dropdown.label.container.find(`.arrow`).css(`visibility`, `hidden`);
    });
  };

  MultiSelector.prototype.set_max_selectors_to_show = function(number_of_selectors) {
    if (number_of_selectors) {
      this.max_selectors_to_show = number_of_selectors;
    } else {
      this.max_selectors_to_show = DEFAULT_MAX_SELECTORS;
    }
  };

  MultiSelector.prototype._add_dropdown = function(values, dropdown_state) {
    values = _.map(values, function(pair) {
      return [pair[0], pair[1] === `` ? `(no name)` : pair[1]];
    });

    var dd_config = {
      color: mp.charts.nth_color(this.dropdowns.length, this.color_scheme),
      emulate_select: true,
      collapse: true,
      disable_selection: this.is_selection_disabled,
      color_checkbox: this.color_checkboxes,
    };
    if (!_.isUndefined(dropdown_state)) {
      dd_config.selected = dropdown_state[0];
    }
    var new_dd = new ColorToggleDropdown().create($(`<div>`).addClass(`color_toggle_dropdown`), values, dd_config);

    if (values.length <= this.max_selectors_to_show) {
      new_dd.disable();
      new_dd.label.container.find(`.arrow`).css(`visibility`, `hidden`);
    }
    if (_.isUndefined(dropdown_state)) {
      new_dd.label.container.find(`.title`).text(this.default_label);
    } else if (!dropdown_state[1]) {
      new_dd.label.toggle_checked(false);
    }

    new_dd.container.find(`.checkbox`).change(_.bind(function() {
      this.callback(this.get_state());
    }, this));

    if (!this.single_dropdown) {
      new_dd.container.bind(`item-selected`, _.bind(function(ev, item, prev) {
        new_dd.label.container.parent().css(`z-index`, 0);
        item.container.parents(`.color_toggle_dropdown`).find(`.checkbox`).addClass(`active`);

        if (!this.is_selected_item_enabled) {
          _.each(this.dropdowns, function(dropdown) {
            dropdown.body.get_item_by_val(item.val()).disable();
            if (!_.isUndefined(prev)) {
              dropdown.body.get_item_by_val(prev.val()).enable();
            }
          }, this);
        }

        this.callback(this.get_state());
      }, this));
    }

    new_dd.label.container.bind(`label-activated`, function(ev, label) {
      label.container.parent().css(`z-index`, 11);
    });
    new_dd.label.container.bind(`label-deactivated`, function(ev, label) {
      label.container.parent().css(`z-index`, 0);
    });

    var handler = function(ev, label) {
      new_dd.label.container.parent().css(`z-index`, 0);
    };
    mp.utility.bind_outside_event(`click`, `color_toggle_dropdown`, new_dd.container, handler);

    if (this.compare_select) {
      new_dd.container.insertBefore(this.compare_select.$el);
    } else {
      this.container.append(new_dd.container);
    }

    this.dropdowns.push(new_dd);
  };

  // values is the list of values you want to display in order
  // selected_state is a list of [<dropdown_value>, <checked>]
  MultiSelector.prototype.update_values = function(values, selected_state, force_redraw) {
    if (_.isUndefined(selected_state)) {
      selected_state = [];
    }

    if (force_redraw || !_.isEqual(values, this.values)) {
      // This gets very expensive, and when we aren't requerying
      // values (which is also when values === this.values) it
      // can cause a noticible browser hang.
      this.reset_container();
      if (values.length === 0) {
        this.container.removeClass(`filled`);
      } else {
        this.container.addClass(`filled`);
      }

      var selected_state_length = _.max([selected_state.length, 1]);
      var num_selectors = _.min([values.length, this.max_selectors_to_show, selected_state_length]);
      this.dropdowns = [];
      for (var i = 0; i < num_selectors; i++) {
        this._add_dropdown(values, selected_state[i]);
      }

      if (this.single_dropdown) {
        this.disable_all_dropdowns();

        var options = _.map(values, function(pair) {
          return {
            value: pair[0],
            label: pair[1] === `` ? `(no name)` : pair[1],
          };
        });
        var selected_values = _.map(selected_state, function(pair) {
          return pair[0];
        });

        this.compare_select.model.update_select_options(options, {silent: true});
        this.compare_select.update_selection(selected_values);
        this.compare_select.$el.toggleClass(`empty`, !options.length);
        this.compare_select.hide_menu();
      }
    }

    if (!this.is_selected_item_enabled && !this.single_dropdown) {
      _.each(this.dropdowns, function(dropdown, dropdown_ix) {
        _.each(selected_state, function(value) {
          var chartToggle = dropdown.body.get_item_by_val(value[0]);
          if (chartToggle) {
            chartToggle.disable();
          }
        }, this);
      }, this);
    }

    this.values = values;
  };

  MultiSelector.prototype.update_static_values = function(values) {
    this.reset_container();
    this.dropdowns = [];
    this.static_state = [];

    _.each(values, function(v, index) {
      var container = $(`<div>`).addClass(`bucket`);
      var color_circle = $(`<div>`).addClass(`color_circle`);
      color_circle.css({
        'border': `1px solid ` + mp.charts.nth_color(index),
        'background-color': mp.charts.nth_color(index),
      });

      var value = v;
      var display_value = v;
      if (_.isArray(v)) {
        value = v[0];
        display_value = v[1];
      }
      if (display_value === ``) {
        display_value = `(no name)`;
      }
      container.append(color_circle, $(`<div>`).addClass(`title`).text(display_value));

      this.static_state.push({
        'checked': true,
        value,
        'color': mp.charts.nth_color(index),
      });

      this.container.append(container);
    }, this);

  };

  MultiSelector.prototype.update_dropdowns = function(selected_values) {
    _.each(_.zip(selected_values, this.dropdowns), function(pair, i) {
      var value = pair[0];
      var dropdown = pair[1];

      if (_.isString(value) && dropdown) {
        dropdown.enable();
        dropdown.select_val(value);
      } else if (_.isString(value) && !dropdown) {
        this._add_dropdown(this.values, [value, true]);
      } else if (!_.isString(value) && dropdown) {
        dropdown.container.remove();
        this.dropdowns.splice(this.dropdowns.indexOf(dropdown), 1);
      }
    }, this);

    if (this.single_dropdown) {
      this.disable_all_dropdowns();
    }

    this.callback(this.get_state());
  };

  MultiSelector.prototype.get_state = function() {
    var state = [];
    if (this.dropdowns.length > 0) {
      _.each(this.dropdowns, function(dropdown, index) {
        state.push({
          'checked': dropdown.container.find(`.checkbox`).is(`.active`),
          'value': dropdown.val(),
          'color': mp.charts.nth_color(index),
        });
      });
    } else {
      state = this.static_state;
    }

    return state;
  };

  // A shorter format than get_state for saving in the hash, since we don't need the colors
  // when saving what values are selected, checked, and not checked
  MultiSelector.prototype.serialize = function() {
    var params = [];
    _.each(this.dropdowns, function(dropdown) {
      params.push([dropdown.val(), dropdown.container.find(`.checkbox`).is(`.active`)]);
    });
    return params;

  };

  // Removes all segment selectors. Used for numeric segments, since we show all the buckets
  MultiSelector.prototype.reset = function() {
    this.reset_container();
    this.dropdowns = [];
  };

  MultiSelector.prototype.close_compare_select = function() {
    this.compare_select.hide_menu();
  };

  return {
    MultiSelector,
  };
});

}.call(window));